const TwoPaneMultiSelectTypes = {
    TOGGLE_ITEM: "2panemultiselect/toggle-item",
    POPULATE: "2panemultiselect/populate",
    HANDLE_SCROLL: "2panemultiselect/handle-scroll",
    UPDATE_POSITIONS: "2panemultiselect/update-positions",
};

export default TwoPaneMultiSelectTypes;



// WEBPACK FOOTER //
// ./app/lib/common/twopanemultiselect/data/TwoPaneMultiSelectTypes.js